export default function Download4({ width = '22', height = '20', color = '#002366' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.0007 14.1667V2.5" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M18.5353 14.1667C18.5353 16.0075 17.0358 17.5 15.1863 17.5H6.81383C4.96435 17.5 3.46484 16.0075 3.46484 14.1667" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M15.1858 10L10.9987 14.1675L6.8125 10" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}
